// extracted by mini-css-extract-plugin
export var closed = "_f7-1";
export var resizer = "_f7-0";